import { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import './ImageCarousel.css';

interface ImageCarouselProps {
    images: string[]
}

const ImageCarousel = ({ images }: ImageCarouselProps) => {
    const [currentIndex, setCurrentIndex] = useState(Math.floor(Math.random() * images.length));
    const [activeTransition, setActiveTransition] = useState('');

    const prevSlide = () => {
        setActiveTransition('prev')
    }

    const nextSlide = () => {
        setActiveTransition('next')
    }

    const handleTransitionEnd = () => {
        setActiveTransition('')
        const isFirstSlide = currentIndex === 0
        const isLastSlide = currentIndex === images.length - 1
        if (activeTransition === 'prev') {
            const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1
            setCurrentIndex(newIndex)
        } else if (activeTransition === 'next') {
            const newIndex = isLastSlide ? 0 : currentIndex + 1
            setCurrentIndex(newIndex)
        }
    }

    const getPrevImage = () => {
        const isFirstSlide = currentIndex === 0;
        return isFirstSlide ? images[images.length - 1] : images[currentIndex - 1];
    }

    const getNextImage = () => {
        const isLastSlide = currentIndex === images.length - 1;
        return isLastSlide ? images[0] : images[currentIndex + 1];
    }

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '400px', overflow: 'hidden', mt: 3 }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${images[currentIndex]})`,
                    backgroundSize: 'cover',
                    filter: 'blur(10px)',
                    zIndex: -1,
                }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', position: 'relative', height: '400px', overflow: 'hidden' }}>
                <Box
                    component="img"
                    className={`image-carousel__previous-image ${activeTransition === 'prev' ? 'active' : ''}`}
                    src={getPrevImage()}
                    alt={`Next slide`}
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
                <Box
                    component="img"
                    className={`image-carousel__current-image ${activeTransition ? `${activeTransition}-active` : ''}`}
                    src={images[currentIndex]}
                    alt={`Slide ${currentIndex}`}
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                    onTransitionEnd={handleTransitionEnd}
                />
                <Box
                    component="img"
                    className={`image-carousel__next-image ${activeTransition === 'next' ? 'active' : ''}`}
                    src={getNextImage()}
                    alt={`Next slide`}
                    sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
            </Box>
            <IconButton
                onClick={prevSlide}
                sx={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', color: 'white' }}
            >
                <ArrowBackIosIcon />
            </IconButton>
            <IconButton
                onClick={nextSlide}
                sx={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', color: 'white' }}
            >
                <ArrowForwardIosIcon />
            </IconButton>
        </Box>
    );
};

export default ImageCarousel;